/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

const assignStatusList = [1, 9, 6];

function userExists(ownership, currentUser) {
  if (ownership.assignedToUser.length > 0) {
    return ownership.assignedToUser.some(el => {
      return el.userName === currentUser && (el.extStatusFlag === 1 || el.extStatusFlag === 9);
    });
  }
  return 0;
}

function setAssigned(ownership) {
  if (
    ownership &&
    ownership.assignedToUser.length === 1 &&
    ownership.assignedToUser[0] &&
    assignStatusList.indexOf(ownership.assignedToUser[0].extStatusFlag) >= 0
  ) {
    return !!(ownership && ownership.assignedToUser && ownership.assignedByUser && ownership.assignedOn);
  } else if (ownership && ownership.assignedToUser.length > 0) {
    return ownership.assignedToUser.some(el => {
      return !!(el && assignStatusList.indexOf(el.extStatusFlag) >= 0);
    });
  } else {
    return false;
  }
}

function setAssignedToOther(ownership, currentUser, isAssigned) {
  return isAssigned && !userExists(ownership, currentUser);
}

function setAssignedToSelf(ownership, currentUser, isAssigned) {
  return isAssigned && userExists(ownership, currentUser);
}

function setAssignedByOther(ownership, currentUser, isAssigned) {
  return isAssigned && ownership?.assignedByUser !== null && ownership.assignedByUser?.userName !== currentUser;
}

function setAssignedBySelf(ownership, currentUser, isAssigned) {
  return isAssigned && ownership?.assignedByUser !== null && ownership.assignedByUser?.userName === currentUser;
}

function setActivated(activity) {
  return !!(activity && activity.readingDto);
}

function setActivatedByOther(activity, currentUser, isActivated) {
  return isActivated && activity.readingDto.userName !== currentUser;
}

function setActivatedBySelf(activity, currentUser, isActivated) {
  return isActivated && activity.readingDto.userName === currentUser;
}

function setSmsOperationInProgress(ownership, currentUser) {
  if (ownership && ownership.assignedToUser.length > 0) {
    return ownership.assignedToUser.some(el => {
      return el?.userName === currentUser && el?.extStatusFlag === 6;
    });
  }
  return false;
}

export class State {
  isAssigned;
  isAssignedToOther;
  isAssignedToSelf;
  isAssignedByOther;
  isAssignedBySelf;
  isActivated;
  isActivatedByOther;
  isActivatedBySelf;
  isSmsOperationInProgress;
  private readonly ownership;
  private readonly activity;
  private readonly currentUser;

  constructor(newState, currentUser) {
    this.ownership = newState.ownership;
    this.activity = newState.activity;
    this.currentUser = currentUser;
    this.isAssigned = setAssigned(this.ownership);
    this.isAssignedToOther = setAssignedToOther(this.ownership, this.currentUser, this.isAssigned);
    this.isAssignedToSelf = setAssignedToSelf(this.ownership, this.currentUser, this.isAssigned);
    this.isAssignedByOther = setAssignedByOther(this.ownership, this.currentUser, this.isAssigned);
    this.isAssignedBySelf = setAssignedBySelf(this.ownership, this.currentUser, this.isAssigned);
    this.isActivated = setActivated(this.activity);
    this.isActivatedByOther = setActivatedByOther(this.activity, this.currentUser, this.isActivated);
    this.isActivatedBySelf = setActivatedBySelf(this.activity, this.currentUser, this.isActivated);
    this.isSmsOperationInProgress = setSmsOperationInProgress(this.ownership, this.currentUser);
  }
}
